import { HomeLayout } from "layouts";
import { runQuery } from "queries";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Cocktails from "pages/cocktails/index.js";

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ locale, params }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      ...(await runQuery("categories/single", { ...params, key: "category" }))
        .props,
      /*
      ...(await runQuery("filters/all", params)).props,
      */
    },
    revalidate: 60,
  };
}

export default Cocktails;
